import { Component, EventEmitter, Input, Output } from '@angular/core';
import { statTableConfig } from './core/stats-table-config';
import { FillIfEmptyValuePipe } from '../../../../common/pipes/fill-if-empty-value.pipe';
import { StatLocation } from '../../../../common/models/statistics/stat-data';
import { ColumnMode, NgxDatatableModule, SortType } from '@swimlane/ngx-datatable';
import { StatTableModel } from './core/stat-table-model';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { DatePipe, DecimalPipe, NgForOf } from '@angular/common';

@Component({
  selector: 'psc-stats-table',
  templateUrl: './stats-table.component.html',
  standalone: true,
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'admin-pages', alias: 'admin-pages' } }],
  imports: [
    NgxDatatableModule,
    TranslocoModule,
    DecimalPipe,
    DatePipe,
    NgForOf,
  ],
})
export class StatsTableComponent {

  basicColumns = statTableConfig.basicColumns;

  @Input() set statistics(value: StatLocation[]) {
    if (!value) {
      return;
    }
    this.statTableData = value.flatMap((loc) => StatTableModel.fromStatData(loc));
  }

  @Input() loading: boolean;
  @Output() locationClicked: EventEmitter<{ lat: string, lng: string }> = new EventEmitter<{
    lat: string;
    lng: string
  }>();

  statTableData: StatTableModel[];

  constructor(
    public fillIfEmptyValuePipe: FillIfEmptyValuePipe,
  ) {
  }

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;

  dateComparator(valueA: string | null, valueB: string | null): number {
    const first = valueA ? Date.parse(valueA) : Number.NaN;
    const second = valueB ? Date.parse(valueB) : Number.NaN;

    if (Number.isNaN(first) && Number.isNaN(second)) {
      return 0;
    }

    if (Number.isNaN(first)) {
      return -1;
    }

    if (Number.isNaN(second)) {
      return 1;
    }

    return first - second;
  }

  onRowSelect(event: {
    type: 'keydown' | 'click' | 'dblclick'
    event: string,
    row: StatTableModel,
    column: any,
    value: any,
    cellElement: string,
    rowElement: string,
  }) {
    if (event.type !== 'keydown' && event.type !== 'click') {
      return;
    }
    this.locationClicked.emit({ lat: event.row.lat, lng: event.row.lng });
  }
}
